import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getSelectedAgenda, getSelectedAgendaReports } from 'lib/reader'
import { getCurrentDate } from 'lib/helper'

import { getAgendaReport, promptCompleteAppointment, promptCancelAppointment } from 'state/actions'

import AppointmentsReportScreen from 'components/_Screens/AppointmentsReport'

class AppointmentsReportContainer extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      year: null,
      month: null,
    }
    this.getReport = this.getReport.bind(this)
    this.refresh = this.refresh.bind(this)
  }

  // Get for initial time period
  UNSAFE_componentWillMount() {
    const { year, month } = getCurrentDate()
    this.getReport({ year, month })
  }

  componentDidUpdate(prevProps) {
    // Update report when agenda changes
    if (prevProps.agenda.id !== this.props.agenda.id) {
      this.getReport(this.state)
    }
  }

  getReport({ year, month }) {
    const { agenda } = this.props
    this.setState({ year, month })
    this.props.getAgendaReport({ id: agenda.id, year, month })
  }
  refresh() {
    const { agenda } = this.props
    const { year, month } = this.state
    this.props.getAgendaReport({ id: agenda.id, year, month })
  }

  // TODO: Should be doing this in reader, no?
  findReport(reports = [], agenda, year, month) {
    return reports.find(r => r.id === `${agenda.id}_${year}_${month}`)
  }

  render() {
    const { year, month } = this.state
    const { agenda, reports, onAppointmentStart, promptCompleteAppointment, promptCancelAppointment, ui, selectedAppointment } = this.props
    const report = this.findReport(reports, agenda, year, month) || {}

    return (
      <AppointmentsReportScreen
        report={report}
        onLoadReportFromDate={this.getReport}
        onAppointmentStart={onAppointmentStart}
        onPromptCompleteAppointment={promptCompleteAppointment}
        onPromptCancelAppointment={promptCancelAppointment}
        onRefresh={this.refresh}
        ui={ui}
        />
    )
  }
}

AppointmentsReportContainer.propTypes = {
  agenda: PropTypes.object.isRequired,
  reports: PropTypes.array.isRequired,
  ui: PropTypes.object.isRequired,
  onAppointmentStart:PropTypes.func.isRequired
}

const mapStateToProps = (state) => ({
  agenda: getSelectedAgenda(state),
  reports: getSelectedAgendaReports(state),
  ui: state.ui,
})

export default connect(
  mapStateToProps,
  { getAgendaReport, promptCompleteAppointment, promptCancelAppointment }
)(AppointmentsReportContainer)



// WEBPACK FOOTER //
// ./src/containers/AppointmentsReport/index.js